import { setInnerHTML } from '@/lib/util';

type LabelProps = {
	htmlFor: string;
	required?: boolean;
	srOnly?: boolean;
	text?: string;
};

const Label = (props: LabelProps) => {
	const labelText = props.required && props.text ? `${props.text}*` : props.text || '';

	return (
		<label
			className={props.srOnly ? 'sr-only' : 'form--label'}
			dangerouslySetInnerHTML={setInnerHTML(labelText)}
			htmlFor={props.htmlFor}
		></label>
	);
};

export { Label };
